import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import EditableText from '../../../ui/forms/EditableText'
import PlanButton from '../../../ui/plans/PlanButton'
import EditableImage from './components/EditableImage'
import DropAndCropModal from '../../../ui/images/DropAndCropModal'
import SA_PopUp from '../../../ui/sweetalert/SA_PopUp'
import { ilsCheck, ilsQuestion } from '../../../ui/Icon'

class ProfileSettingsCard extends Component {
    constructor(props) {
        super(props)

        this.state = {
             bioEditMode: false,
             showModal: '',
             profileImage: props.image
        }
    }

    /**
     * Renders
     */
    
    render() {
        return (
            <div className="profile-settings-card">
                {this.renderCardHeader()}
                {this.renderCardBody()}
                {this.renderModals()}
            </div>
        )
    }

    renderCardHeader() {
        const {
            title,
            subtitle,
            button: PlanButton = () => null
        } = this.props;

        const { profileImage } = this.state;

        return (
            <div className="profile-settings-card-header">
                <EditableImage
                    src={profileImage}
                    roundedCircle
                    name={title}
                    onClick={() => this.setShowModal('upload_profile_modal')}
                />
                <h3 className="title">{title}</h3>
                <p className="subtitle">{subtitle}</p>
                <PlanButton plan="gold" />
            </div>
        )
    }

    renderCardBody() {
        const { bioEditMode } = this.state;
        const { userBio } = this.props;

        return (
            <div className="profile-settings-card-body">
                <strong className="title">Bio</strong>
                <EditableText
                    editMode={bioEditMode}
                    onChange={console.log}
                    defaultValue={userBio}
                />
                <Button 
                    variant="link" 
                    onClick={this.toggleEditableBio}
                >
                    {bioEditMode ? 'Save' : userBio ? 'Edit Bio' : 'Add Bio'}
                </Button>
            </div>
        )
    }

    renderModals = () => {
        const { showModal } = this.state;
        
        return (
            <DropAndCropModal
                show={showModal === 'upload_profile_modal'}
                onHide={() => this.setShowModal('')}
                onSubmit={this.handleUploadImage}
            />
        )
    }

    /**
     * Handlers
     */

    toggleEditableBio = () => {
        const { bioEditMode } = this.state;

        if (bioEditMode) {
            new SA_PopUp().fire({}, {
                title: 'Confirm',
                text: 'Are you sure you want to change your Bio?',
                image: ilsCheck
            }).then(value => {
                if(value) {
                    this.setState(prevState => ({
                        bioEditMode: !prevState.bioEditMode
                    }))
                }
            })
        } else {
            this.setState(prevState => ({
                bioEditMode: !prevState.bioEditMode
            }))
        }
    }

    setShowModal = modal => {
        this.setState({ showModal: modal });
    }

    handleUploadImage = uploadedImage => {
        this.setState({ profileImage: uploadedImage, showModal: '' });
    }

    /**
     * Props
     */

    static propTypes = {
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string,
        image: PropTypes.string,
        button: PropTypes.element,
        userBio: PropTypes.string
    }

    static defaultProps = {
        title: 'Jack Scot',
        subtitle: 'Scout | Real Madrid',
        image: require('../../../../assets/img/demo/profile-settings-avatar.png'),
        button: PlanButton,
        userBio: "Amet consectetur labore cillum laboris non amet amet eiusmod dolore commodo velit deserunt dolor. Non deserunt enim minim eiusmod sit sint. Ex tempor deserunt deserunt esse eu ipsum adipisicing. Amet consectetur labore cillum laboris non amet amet eiusmod dolore commodo velit deserunt dolor. Non deserunt enim minim eiusmod sit sint. Ex tempor deserunt deserunt esse eu ipsum adipisicing."
    }
}

export default ProfileSettingsCard
